<template>
  <div v-loading="StrategyLoading" class="Strategy">
    <div class="Strategy-table">
      <div class="doctor-table-id-one">
        <div class="Strategy">策略名称</div>
        <div class="Strategy-Show">
          {{ DataList.strategy_name ? DataList.strategy_name : '-' }}
        </div>
      </div>
      <div class="doctor-table-id">
        <div class="Strategy">关注领域</div>
        <div class="Strategy-show">
          <div class="Strategy-show-list">
            {{ newField && newField.length > 0 ? newField.map((i) => i).join(', ') : '-' }}
          </div>
        </div>
      </div>
      <div class="doctor-table-id">
        <div class="Strategy">关注科室</div>
        <div class="Strategy-show">
          <div class="Strategy-show-list">
            {{
              newDepmentlist && newDepmentlist.length > 0
                ? newDepmentlist.map((i) => i).join(', ')
                : '-'
            }}
          </div>
        </div>
      </div>
      <div class="doctor-table-id">
        <div class="Strategy">医生职称</div>
        <div class="Strategy-show">
          <div class="Strategy-show-list">
            {{
              newDoctorTitle && newDoctorTitle.length > 0
                ? newDoctorTitle.map((i) => i).join(',')
                : '-'
            }}
          </div>
        </div>
      </div>
      <div class="doctor-table-id">
        <div class="Strategy">医生等级</div>
        <div class="Strategy-show">
          {{
            DataList.doctor_levels && DataList.doctor_levels.length > 0
              ? DataList.doctor_levels.join(', ')
              : '-'
          }}
        </div>
      </div>
      <div class="doctor-table-id">
        <div class="Strategy">医生性别</div>
        <div class="Strategy-show">
          {{ gener ? (gener === 1 ? '男' : '女') : '-' }}
        </div>
      </div>
      <div class="doctor-table-id">
        <div class="Strategy">医生所在地区</div>
        <div class="Strategy-show">
          {{ DataList.province + DataList.city + DataList.area || '-' }}
        </div>
      </div>
      <div class="doctor-table-id">
        <div class="Strategy">医生所属医院</div>
        <div class="Strategy-show">
          <span v-for="hospital in hospitals" :key="hospital.hospital_id">
            {{ hospital.hospital_name }}
          </span>
        </div>
      </div>
      <div class="doctor-table-id">
        <div class="Strategy">公众号</div>
        <div class="Strategy-show">
          {{ newAppIDs && newAppIDs.length > 0 ? newAppIDs.join(',') : '-' }}
        </div>
      </div>
      <div class="doctor-table-id-last">
        <div class="Strategy">备注</div>
        <div class="Strategy-show">
          {{ DataList.remark ? DataList.remark : '-' }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getStrategyDetail, getDomainInfoListApi, getAppListApi } from '@/api/setUser.js';
import { getHospitalDepartmentListApi, QueryTitleList } from '@/api/setUp.js';
export default {
  data() {
    return {
      StrategyLoading: false, // 全局Loading
      id: '', // id
      DataList: {}, // 策略详情
      depmentlist: [], // 科室列表
      DoctorTitle: [], // 医生职称
      gener: '', // 性别
      fieldlist: [], // 领域
      titlelist: [], // 职称
      province: '', // 省
      city: '', // 市
      ProvinceList: [],
      newField: [],
      newDepmentlist: [],
      newDoctorTitle: [],
      appIDs: [],
      newAppIDs: [],
      hospitals: [],
    };
  },
  created() {
    this.getUpdata();
  },
  methods: {
    // 获取策略详情
    getUpdata() {
      this.getDetail();
    },
    getDetail() {
      this.StrategyLoading = true;
      const req = { id: this.$route.query.id };
      getStrategyDetail(req)
        .then((res) => {
          this.DataList = res;
          this.gener = this.DataList.gender ? this.DataList.gender : '';
          this.hospitals = this.DataList.hospitals;
          const getDomain = getDomainInfoListApi()
            .then((res) => {
              this.fieldlist = res.list;
              for (let i = 0; i < this.DataList.domain_ids.length; i++) {
                for (let j = 0; j < this.fieldlist.length; j++) {
                  if (Number(this.DataList.domain_ids[i]) === Number(this.fieldlist[j].id)) {
                    this.newField.push(this.fieldlist[j].domain_name);
                  }
                }
              }
            })
            .catch((e) => {
              this.$message.error(e.message);
            });
          const HospitalDepartment = getHospitalDepartmentListApi()
            .then((res) => {
              this.depmentlist = res.data;
              for (let i = 0; i < this.DataList.doctor_department_ids.length; i++) {
                for (let j = 0; j < this.depmentlist.length; j++) {
                  if (
                    Number(this.DataList.doctor_department_ids[i]) ===
                    Number(this.depmentlist[j].department_id)
                  ) {
                    this.newDepmentlist.push(this.depmentlist[j].department_name);
                  }
                }
              }
            })
            .catch((e) => {
              this.$message.error(e.message);
            });
          const getAppList = getAppListApi()
            .then((res) => {
              this.appIDs = res.list;
              for (let i = 0; i < this.DataList.app_ids.length; i++) {
                for (let j = 0; j < this.appIDs.length; j++) {
                  if (this.DataList.app_ids[i] === this.appIDs[j].app_id) {
                    this.newAppIDs.push(this.appIDs[j].app_name);
                  }
                }
              }
            })
            .catch((e) => {
              this.$message.error(e.message);
            });
          const queryTitleList = QueryTitleList({ page_index: 1, page_size: 9999 })
            .then((res) => {
              this.DoctorTitle = res.data || [];
              for (let i = 0; i < this.DataList.doctor_title_ids.length; i++) {
                for (let j = 0; j < this.DoctorTitle.length; j++) {
                  if (
                    Number(this.DataList.doctor_title_ids[i]) ===
                    Number(this.DoctorTitle[j].title_id)
                  ) {
                    this.newDoctorTitle.push(this.DoctorTitle[j].title_name);
                  }
                }
              }
            })
            .catch((e) => {
              this.$message.error(e.message);
            });
          Promise.all([getDomain, HospitalDepartment, getAppList, queryTitleList]).then(() => {
            this.StrategyLoading = false;
          });
        })
        .catch((e) => {
          this.$message.error(e.message);
          this.StrategyLoading = false;
        });
    },
  },
};
</script>
<style scoped lang="scss">
.Strategy {
  width: 100%;
  height: 100%;
  padding: 0 24px;
  position: relative;
  overflow: auto;
  .doctor-details {
    position: relative;
    height: 80px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #303133;
    .doctor-details-img {
      position: absolute;
      top: 32.5px;
      left: 0;
      width: 24px;
      height: 24px;
      transform: rotateY(180deg);
    }
    .doctor-details-return {
      position: absolute;
      top: 36px;
      width: 44px;
      height: 22px;
      left: 28px;
      font-family: PingFangSC-Regular;
      font-size: 16px;
      color: #606266;
      letter-spacing: 0;
      cursor: pointer;
    }
    .doctor-details-return:hover {
      color: rgb(47, 150, 255);
    }
  }
  .Strategy-table {
    margin-top: 24px;
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    font-size: 16px;
    width: 100%;
    font-family: PingFangSC-Regular;
    .doctor-table-id {
      display: flex;
      width: 100%;
      height: 56px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.08);
      .Strategy {
        flex: 0.21;
        height: 56px;
        // opacity: 0.65;
        // background: #F5F7FA;
        background: rgba(245, 247, 250, 0.65);
        padding-left: 24px;
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #303133;
        letter-spacing: 0;
        line-height: 56px;
      }
      .Strategy-show {
        flex: 0.79;
        height: 56px;
        background: rgba(216, 216, 216, 0);
        padding-left: 24px;
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #303133;
        letter-spacing: 0;
        line-height: 56px;
        .Strategy-show-list {
          display: inline-block;
        }
        .Strategy-show-list:nth-of-type(n + 2) {
          margin-left: 10px;
        }
      }
    }
    .doctor-table-id-one {
      display: flex;
      width: 100%;
      height: 56px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.08);
      .Strategy {
        flex: 0.21;
        height: 56px;
        // opacity: 0.65;
        // background: #F5F7FA;
        background: rgba(245, 247, 250, 0.65);
        padding-top: 8px;
        padding-left: 24px;
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #303133;
        letter-spacing: 0;
        // line-height: 28px;
        line-height: 48px;
      }
      .Strategy-Show {
        flex: 0.79;
        height: 48px;
        background: rgba(216, 216, 216, 0);
        padding-top: 8px;
        padding-left: 24px;
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #303133;
        letter-spacing: 0;
        line-height: 48px;
      }
    }
    .doctor-table-id-last {
      display: flex;
      width: 100%;
      height: 67px;
      .Strategy {
        flex: 0.21;
        height: 67px;
        // opacity: 0.65;
        // background: #F5F7FA;
        background: rgba(245, 247, 250, 0.65);
        padding-top: 24px;
        padding-left: 24px;
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #303133;
        letter-spacing: 0;
      }
      .Strategy-show {
        flex: 0.79;
        height: 48px;
        background: rgba(216, 216, 216, 0);
        padding-top: 8px;
        padding-left: 24px;
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #303133;
        letter-spacing: 0;
        line-height: 48px;
      }
    }
  }
}
</style>
